import axios from 'axios'
import Toast from 'muse-ui-toast'
import main from './../main'
Toast.config({
  position: 'top'
})

const backend = axios.create()
// http request 拦截器
backend.interceptors.request.use(
  config => {
    return config
  },
  err => {
    return Promise.reject(err)
  }
)
backend.interceptors.response.use(
  response => {
    let data = response.data
    if (data.statusCode !== 200) {
      Toast.error(data.msg)
    }
    // 未登录
    if (data.statusCode === 401) {
      main.$router.push('/login')
    }
    return data
  },
  err => {
    return Promise.reject(err)
  }
)

export default (api, data, onUploadProgress) => {
  if (api.method === 'put' || api.method === 'post' || api.method === 'patch') {
    api.data = data
  } else {
    api.params = data
  }
  if (onUploadProgress) {
    api.onUploadProgress = onUploadProgress
  }
  return backend(api)
}

export const downloadFileByTagA = (url, fileName) => {
  console.log('fileName', fileName)
  fetch(url)
    .then(response => response.blob())
    .then(blob => {
      const blobUrl = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = blobUrl
      a.download = fileName
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      window.URL.revokeObjectURL(blobUrl)
    })
    .catch(error => {
      console.error('下载失败:', error)
      const a = document.createElement('a')
      a.href = url
      a.download = fileName
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    })
}



// WEBPACK FOOTER //
// ./src/utils/backend.js